/* istanbul ignore file */
function isPlatformMac() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
export { isPlatformMac };
//# sourceMappingURL=platformUtil.js.map
